import { ENGLISH_LANGUAGE } from "./english.data";
import { FRENCH_LANGUAGE } from "./french.data";

export const selectLanguage = (language: "en" | "fr") => {
  switch (language) {
    case "en":
      return ENGLISH_LANGUAGE;
    case "fr":
      return FRENCH_LANGUAGE;

    default:
      return ENGLISH_LANGUAGE;
  }
};
